import { Outlet } from "react-router";
import { ActiveDeviceChip } from "./ActiveDeviceChip.tsx";
import { useConnectionState } from "../shared/realtime/RealtimeProvider.tsx";
import { DeviceIcon, HomeIcon, ProfileIcon } from "../shared/ui/icons.tsx";
import { Logo } from "../shared/ui/Logo.tsx";
import { TabBar, type TabBarItem } from "../shared/ui/TabBar/TabBar.tsx";
import styles from "./AppShell.module.css";

const tabs: TabBarItem[] = [
  { to: "/feed", label: "Лента", icon: HomeIcon },
  { to: "/eva", label: "E-va", icon: DeviceIcon },
  { to: "/profile", label: "Аккаунт", icon: ProfileIcon },
];

/** Оболочка залогиненного приложения: баннер связи, шапка (Layout / App Header) и нижний TabBar. */
export function AppShell() {
  const connection = useConnectionState();
  return (
    <>
      {connection === "unstable" && <UnstableConnectionBanner />}
      <header className={styles.header}>
        {/* Brand / Logo в шапке — 97.325×38 (Figma 937:2953). */}
        <Logo width="97.325" height="38" />
        <ActiveDeviceChip />
      </header>
      <div className={styles.content}>
        <Outlet />
      </div>
      <TabBar items={tabs} />
    </>
  );
}

/**
 * Unstable Connection Warning (Figma 1029:24378), общий для всех табов: 07.05, 08.09, 09.05.
 */
function UnstableConnectionBanner() {
  return (
    <div className={styles.banner} role="status">
      <strong>Нестабильное соединение.</strong> Статусы обновятся, когда связь восстановится.
    </div>
  );
}
